import type { ChatDetail, ChatMessage, ChatThread } from '../model/types';
import type { ChatPinnedMessageDTO } from '../api/dto';

export function normalizePinnedDtos(
  pinnedMessage?: ChatPinnedMessageDTO | null,
  pinnedMessages?: ChatPinnedMessageDTO[] | null,
): ChatPinnedMessageDTO[] {
  if (pinnedMessages?.length) {
    return pinnedMessages;
  }

  if (pinnedMessage) {
    return [pinnedMessage];
  }

  return [];
}

export function mergePinnedMessages(
  current: ChatMessage[],
  additions: ChatMessage[],
): ChatMessage[] {
  const seen = new Set<number>();
  const merged: ChatMessage[] = [];

  for (const message of [...additions, ...current]) {
    if (seen.has(message.id)) {
      continue;
    }

    seen.add(message.id);
    merged.push(message);
  }

  return merged;
}

export function resolvePinnedMessages(
  pinned: ChatMessage[],
  messages: ChatMessage[],
): ChatMessage[] {
  return pinned.map((item) => messages.find((message) => message.id === item.id) ?? item);
}

export function isMessagePinned(pinned: ChatMessage[], messageId: number): boolean {
  return pinned.some((item) => item.id === messageId);
}

export function getEffectivePinnedForChat(
  chatId: number,
  pinnedByChatId: Record<number, ChatMessage[]>,
  thread?: Pick<ChatThread, 'id' | 'pinnedMessage'> | null,
  detail?: Pick<ChatDetail, 'id' | 'pinnedMessage'> | null,
): ChatMessage[] {
  const local = pinnedByChatId[chatId] ?? [];
  const fromThread =
    thread && thread.id === chatId && thread.pinnedMessage ? [thread.pinnedMessage] : [];
  const fromDetail =
    detail && detail.id === chatId && detail.pinnedMessage ? [detail.pinnedMessage] : [];

  return mergePinnedMessages(mergePinnedMessages(local, fromThread), fromDetail);
}
